import React from 'react'

import { css } from '@emotion/core'
import { useTheme } from 'emotion-theming'
import Relazsizes from 'relazsizes'

import Container from 'components/layouts/atoms/Container'
import SectionContainer from 'components/layouts/atoms/SectionContainer'
import Typography from 'components/common/atoms/Typography'

import KoinworksCriteriaData from './KoinworksCriteriaData.json'

const koinworksCriteriaStyle = css`
  .koinworks-criteria {
    &__row {
      margin: 24px 0 0 0;
    }
    &__col {
      display: flex;
      &:not(:first-of-type) {
        margin-top: 24px;
      }
      img {
        width: 86px;
        height: 100%;
        margin-right: 16px;
      }
    }
    &__text {
      p {
        margin-top: 8px;
      }
    }
    @media screen and (min-width: 768px) {
      &__wrapper {
        text-align: center;
      }
      &__row {
        display: flex;
        margin: 40px 86px 0 86px;
      }
      &__col {
        padding: 40px 16px;
        background-color: #fff;
        border-radius: 10px;
        box-shadow: 0 2px 12px 0 rgba(26, 52, 79, 0.1);
        flex: 1 1 50%;
        display: block;
        &:not(:first-of-type) {
          margin: 0 0 0 80px;
        }
        img {
          height: 127px;
          width: auto;
          margin: 34px auto;
          display: block;
        }
      }
      &__text {
        p {
          margin-top: 16px;
        }
      }
    }
  }
`

const KoinworksCriteria = () => {
  const theme: ThemeType = useTheme()
  return (
    <div className="koinworks-criteria" css={koinworksCriteriaStyle}>
      <SectionContainer backgroundColor={theme.gray.gray10} withPaddingBottom>
        <Container>
          <div className="koinworks-criteria__wrapper">
            <Typography variant="title" level="2" tagName="h2" fontWeight="bold">
              Kriteria
            </Typography>
            <div className="koinworks-criteria__row">
              {KoinworksCriteriaData.map((item, idx) => (
                <div className="koinworks-criteria__col" key={`criteria-${idx}`}>
                  <Relazsizes dataSrc={`/next-assets/images/koinworks/criteria/${item.img}.png`} alt={item.title} />
                  <div className="koinworks-criteria__text">
                    <Typography variant="heading" level="1" tagName="h3" fontWeight="bold">
                      {item.title}
                    </Typography>
                    <Typography variant="paragraph" level="1" tagName="p">
                      {item.description}
                    </Typography>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Container>
      </SectionContainer>
    </div>
  )
}

export default KoinworksCriteria
